import React from 'react'
import SubNavigationBar from 'components/SubNavigation'
import { NavLink, Outlet } from 'react-router-dom'
import { NavItem } from 'reactstrap'

export default () => {
    return (
        <React.Fragment>
            <SubNavigationBar>
                <NavItem>
                    <NavLink
                        className={ ({ isActive, isPending }) =>
                            isPending ? 'pending' : isActive ? 'active' : ''
                        }
                        to="/incidents/export"
                    >
                        Exporteren
                    </NavLink>
                </NavItem>
            </SubNavigationBar>
            <Outlet/>
        </React.Fragment>
    )
}
